export const NEXT_PUBLIC_BREVO_CLIENT_KEY =
  process.env.NEXT_PUBLIC_BREVO_CLIENT_KEY || "";
